<script>
import { authMethods } from '@state/helpers'
import AuthLayout from '@layouts/auth.vue'

export default {
  page: {
    title: 'Pamiršai slaptažodį?',
  },

  components: { AuthLayout },

  data() {
    return {
      email: '',
      errorMessage: null,
      isLoading: false,
    }
  },

  methods: {
    ...authMethods,

    onSubmitForm() {
      this.isLoading = true
      this.errorMessage = null

      return this.remindPassword({
        email: this.email,
      })
        .then(() => {
          this.isLoading = false
          this.$router.push({ name: 'password-remind-sent' })
        })
        .catch(() => {
          this.isLoading = false
          this.errorMessage = 'Įveskite teisingą el. pašto adresą.'
        })
    },
  },
}
</script>

<template>
  <AuthLayout>
    <template v-slot:title> Pamiršai slaptažodį? </template>

    <p v-if="errorMessage" class="text-error mb-4">
      {{ errorMessage }}
    </p>

    <form @submit.prevent="onSubmitForm">
      <div class="mb-4">
        <base-label-input
          v-model="email"
          type="email"
          label="El. pašto adresas"
          :error="!!errorMessage"
          autofocus
        />
      </div>

      <div>
        <base-submit :loading="isLoading"> Gauti instrukcijas </base-submit>
      </div>
    </form>

    <div class="mt-8 text-center font-medium text-sm">
      <router-link :to="{ name: 'login' }"> Prisijungimas </router-link>
    </div>
  </AuthLayout>
</template>
